import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import api from '~/api/pipelines';

type ApiVariables = Parameters<typeof api.pipelineProjectName>[0];

type PipelineProjectNameVariables = Omit<ApiVariables, 'environment'> &
  Partial<Pick<ApiVariables, 'environment'>>;

export const usePipelineProjectName = () => {
  const queryClient = useQueryClient();

  const fetchPipelineProjectName = useCallback(
    (variables: PipelineProjectNameVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'pipelineProjectName',
          variables.realm,
          variables.id,
          variables.pipelineMajorVersion
        ],
        queryFn: () => api.pipelineProjectName(variables as ApiVariables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchPipelineProjectName };
};
